import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SustainabilityEntryHeaderComponent } from './sustainability-entry-header/sustainability-entry-header.component';
import { SustainabilityEntryTableComponent } from './sustainability-entry-table/sustainability-entry-table.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SustainabilityEntryDialogComponent } from './sustainability-entry-dialog/sustainability-entry-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';
import 'ag-grid-enterprise';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { DateUtility } from '../../common/utilities/date.utility';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NgSelectModule } from '@ng-select/ng-select';
import { PagesRouteGuard } from '../../common/utilities/pages.routeguard';
import { DirectivesModule } from '../../common/directives/directives.module';
import { SustainabilityChartComponent } from './sustainability-chart/sustainability-chart.component';


@NgModule({
  declarations: [
    SustainabilityEntryHeaderComponent,
    SustainabilityEntryTableComponent,
    SustainabilityEntryDialogComponent,
    SustainabilityChartComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    AgGridModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatCardModule,
    MatDividerModule,
    MatNativeDateModule,
    MatMenuModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    NgxChartsModule,
  ],
  exports: [
    SustainabilityEntryHeaderComponent,
    SustainabilityEntryTableComponent,
    SustainabilityChartComponent
  ],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DateUtility.CALENDER_DATE_FORMAT },
    PagesRouteGuard
  ]
})
export class SustainabilityEntryModule { }
